import styled from "styled-components";
import Button, { ButtonProps } from "@mui/material/Button";

export const Container = styled.div`
  height: 100vh;

  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  padding: 24px 16px;

  .containerInfo {
    display: flex;
    flex-direction: column;

    align-items: center;
    flex: 1;
    justify-content: center;
  }

  text-align: center;

  h2 {
    font-weight: 400;
    font-size: 24px;
    text-align: center;
    letter-spacing: 0.15px;
    color: #1b2852;

    margin-top: 24px;
    white-space: pre-line;
  }

  p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 21px;
    text-align: center;
    letter-spacing: 0.15px;
    color: #69769b;

    margin-top: 16px;
    margin-bottom: 24px;
    white-space: pre-line;
  }
`;

export const Dash = styled.div`
  width: 100% + 24px;
  margin-left: -24px;
  height: 1px;
  background-color: #d9dff8;
`;

export const ContainerContacts = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 8px 30px 8px;

  h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;

    letter-spacing: 0.15px;
    color: #1b2852;

    margin: 24px 0 12px 0;
  }
`;

export const ContainerContact = styled.div``;

export const Contact = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  width: 100%;

  p {
    text-transform: none;
    margin: 12px 0;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;

    color: #1b2852;
  }

  p:first-child {
    color: #006bee;
    margin-left: 16px;
  }
`;

type StatusType = "success" | "warning" | "denied";

const setColor = (status: StatusType): string => {
  switch (status) {
    case "success":
      return "#42BDAE";

    case "denied":
      return "#F03C51";

    case "warning":
      return "#F07D3C";

    default:
      return "#42BDAE";
  }
};

export const Circle = styled.div<{ status: StatusType }>`
  width: 48px;
  height: 48px;
  border-radius: 24px;
  background-color: ${(props) => setColor(props.status)};
  justify-content: center;
  align-items: center;
  display: flex;
  margin-bottom: 24px;
`;

export const ButtonStyled = styled(Button)<ButtonProps>({
  width: "100%",
  maxWidth: 360,
  textTransform: "capitalize",
});
